import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { v4 as uuidv4 } from "uuid";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Status from "../../Status";
import moment from "moment";
import { ordenarPorTallaYColor } from "../../../../utils/tallas";
import { abrirPDF } from "../../../../utils/abrirPDF";

// Renglones del PDF: [Articulo, Color, Talla, Fecha, Corte, Cliente, Pedido, Cantidad].
// Por corte + fecha + artículo; dentro, talla ascendente y luego color.
const ordenarTallasPDF = (rows) =>
  ordenarPorTallaYColor(
    rows,
    (r) => r[2],
    (r) => r[1],
    (r) => `${r[4]}|${r[3]}|${r[0]}`
  );

function ListadoEntradasAlmacen() {
  const { user } = useContext(AuthContext);
  const URL_ENTRADAS_ALMACEN_ACUMULADOS = process.env.REACT_APP_URL_ENTRADAS_ALMACEN_ACUMULADOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 7);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");


  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [totalCantidad, setTotalCantidad] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_ENTRADAS_ALMACEN_ACUMULADOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCortes = response.data;
        // Array para pagination
        let arrayTabla = allCortes
          .sort((a, b) => (a.idCorte > b.idCorte ? 1 : -1))
          .map((a) => {
            const corte0 = a.cortes && a.cortes[0] ? a.cortes[0] : null;
            const ped = corte0 && corte0.pedidos && corte0.pedidos[0] ? corte0.pedidos[0] : null;
            return {
              _id: a._id,
              corte: corte0 && corte0.ordenesCorte && corte0.ordenesCorte[0] ? corte0.ordenesCorte[0].numero : "",
              fecha: a.fecha,
              cantidad: a.cantidad,
              articulo: a.articulos && a.articulos[0] ? (a.articulos[0].codigoCliente + " " + a.articulos[0].codigo + " " + a.articulos[0].descripcion) : "",
              pedido: ped ? ped.idPedido : "Directa",
              cliente: ped && ped.clientes && ped.clientes[0] ? ped.clientes[0].nombre_comercial : "Producción directa",
              talla: a.tallas && a.tallas[0] ? a.tallas[0].name : "",
              color: a.colores && a.colores[0] ? a.colores[0].name : "",
            };
          })
          .filter(function (el) {
            return el != null;
          });


        let dataFinal = Object.values(arrayTabla);

        // let agrupado = dataFinal.reduce(function (groups, item) {
        //   const val = item["corte"]
        //   groups[val] = groups[val] || {
        //     corte: item.corte,
        //     cantidad:0
        //   };
        //   groups[val].cantidad += item.cantidad;
        //   groups[val].articulo = item.articulo;
        //   groups[val].corte = item.corte;
        //   groups[val].fecha = item.fecha;
        //   groups[val].cliente = item.cliente;
        //   groups[val].pedido = item.pedido;
        //   return groups;
        // },[])
        // let dataFinal2 = Object.values(agrupado);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaCortes = comments.sort((a, b) => (a.idCorte < b.idCorte ? 1 : -1));

  function PDFTabla() {
    const data = comments.map((a) => { {
        return [a.articulo, a.color, a.talla, a.fecha, a.corte, a.cliente, a.pedido, a.cantidad];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Entradas Almacen`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Articulo", "Color", "Talla", "Fecha", "Corte", "Cliente", "Pedido", "Cantidad"]],
      body: ordenarTallasPDF(dataPDFLimpia),
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCantidad)
        ]
      ],
      showFoot: "lastPage",
    });
    // doc.save(`Cortes.pdf`);
    abrirPDF(doc);
  }

  // function PDFTablaGlobal() {
  //   const data = comments.map((a) => { {
  //     let agrupado = data.reduce(function (groups, item) {
  //         const val = item["corte"]
  //         groups[val] = groups[val] || {
  //           corte: item.corte,
  //           cantidad:0
  //         };
  //         groups[val].cantidad += item.cantidad;
  //         groups[val].articulo = item.articulo;
  //         groups[val].corte = item.corte;
  //         groups[val].fecha = item.fecha;
  //         groups[val].cliente = item.cliente;
  //         groups[val].pedido = item.pedido;
  //         return groups;
  //       },[])
  //       let dataFinal2 = Object.values(agrupado);

  //       const data2 = dataFinal2.map((a) => {
  //         return [a.articulo, a.fecha, a.corte, a.cliente, a.pedido, a.cantidad];
    
  //       })
  //     }
  //   });

  //   const dataPDF = Object.values(data);

    


  //   const dataPDFLimpia = dataPDF.filter(function (el) {
  //     return el != null;
  //   });
  //   const doc = new jsPDF("landscape");
  //   var img = new Image();
  //   img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //   doc.addImage(img, "png", 230, 30, 45, 15);
  //   var img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "png", 120, 15, 60, 25);
  //   doc.text(`Listado Entradas Almacen`, 20, 30);
  //   doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
  //   doc.autoTable({
  //     head: [["Articulo", "Fecha", "Corte", "Cliente", "Pedido", "Cantidad"]],
  //     body: dataPDFLimpia,
  //     startY: 45,
  //     foot: [
  //       [
  //         "",
  //         "",
  //         "",
  //         "",
  //         "Total",
  //         new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCantidad)
  //       ]
  //     ],
  //     showFoot: "lastPage",
  //   });
  //   // doc.save(`Cortes.pdf`);
  //   abrirPDF(doc);
  // }

  function excel() {
    const dataExcel = ListaCortes.map((a) => {
        return {
          Articulo: a.articulo,
          Color: a.color,
          Talla: a.talla,
          Fecha: a.fecha,
          Corte: a.corte,
          Cliente: a.cliente,
          Pedido: a.pedido,
          Cantidad: a.cantidad,
        };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoEntradasAlmacen";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoEntradasAlmacen",
        sheetFilter: ["Articulo", "Color", "Talla", "Fecha", "Corte", "Cliente", "Pedido", "Cantidad"],
        sheetHeader: ["Articulo", "Color", "Talla", "Fecha", "Corte", "Cliente", "Pedido", "Cantidad"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => { {
      return [a.articulo, a.color, a.talla, a.fecha, a.corte, a.cliente, a.pedido, a.cantidad];
    }
  });
  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });
  const doc = new jsPDF("landscape");
  var img = new Image();
  img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  doc.addImage(img, "png", 230, 30, 45, 15);
  var img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", 120, 15, 60, 25);
  doc.text(`Listado Entradas Almacen`, 20, 30);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
  doc.autoTable({
    head: [["Articulo", "Color", "Talla", "Fecha", "Corte", "Cliente", "Pedido", "Cantidad"]],
    body: ordenarTallasPDF(dataPDFLimpia),
    startY: 45,
    foot: [
      [
        "",
        "",
        "",
        "",
        "",
        "",
        "Total",
        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCantidad)
      ]
    ],
    showFoot: "lastPage",
  });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Entradas Almacen",
          email: mailTo,
          fileName: "ListadoEntradasAlmacen.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Cortes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Articulo", field: "articulo", sortable: true },
    { name: "Color", field: "color", sortable: true },
    { name: "Talla", field: "talla", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Corte", field: "corte", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Pedido", field: "pedido", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.color.toLowerCase().includes(search.toLowerCase()) ||
          comment.talla.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.corte.toString().includes(search) ||
          comment.pedido.toString().includes(search) 
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    let cant = computedComments.map((c) => parseFloat(c.cantidad));
    let TCant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalCantidad(TCant);


    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "pedido" &&
      sorting.field != "ocrte" 
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "pedido" ||
        sorting.field == "corte" )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "pedido" ||
        sorting.field == "corte" )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
  ]);


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
              {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTablaGlobal}
                >
                  PDF Global <i class="far fa-file-pdf"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cut" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Entradas Almacen
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.articulo}</td>
                      <td>{a.color}</td>
                      <td>{a.talla}</td>
                      <td>{a.fecha}</td>
                      <td>{a.corte}</td>
                      <td>{a.cliente}</td>
                      <td>{a.pedido}</td>
                      <td>{a.cantidad}</td>
                    </tr>
                  );
                }
              })}
              <tr>
              <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalCantidad)}
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Listado Entradas Almacen</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoEntradasAlmacen;
